<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="center"><a id="pvii"></a> <em>As ever, to</em> <span style="font-size: smaller">SARAH</span> <em>and to</em><br/>
<span style="font-size: smaller">TONY LEWIS</span> <em>and</em> <span style="font-size: smaller">MARGIE MARSHALL</span></p></blockquote>
<p class="timebreak"> <br/></p>
<blockquote><p class="center"><em>and in memory of</em><br/>
<span style="font-size: smaller">PAT THOMPSON</span></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?92fa0bc8